import NOTICE_CONFIG from './NOTICE_CONFIG';
import NOTICE_DEFAULT_DATA from './NOTICE_DEFAULT_DATA';

export default {
    CONFIG: NOTICE_CONFIG,
    DEFAULT_DATA: NOTICE_DEFAULT_DATA
}